'use client'
import Script from "next/script"

const PropertyLdJson = ({ property }) => {

    const { category, features } = property

    const amenityFeature = []

    if (features.length > 0) {
        features.forEach(feature => {
            amenityFeature.push({
                "@type": "LocationFeatureSpecification",
                "name": feature.toLowerCase()
            })
        })
    }

    let jsonLd = {}

    let schemaType

    switch (category) {
        case 'Condo':
            schemaType = 'Apartment'
            jsonLd = {
                '@context': 'https://schema.org',
                '@type': schemaType,
                name: property.name,
                description: property.shortDesc,
                url: `${process.env.NEXT_PUBLIC_JSON_LD}/properties/${property.slug}`,
                image: property.cover,
                numberOfBedrooms: property.bedrooms,
                floorSize: {
                    "@type": "QuantitativeValue",
                    "value": property.livingArea,
                    "unitCode": "MTK"
                },
                "geo": { "@type": "GeoCoordinates", "latitude": Number(property.latitude), "longitude": Number(property.longitude) },
            }
            amenityFeature.length > 0 ? jsonLd.amenityFeature = amenityFeature : ''
            property.isPetFriendly ? jsonLd.petsAllowed = true : ''

            break;
        case 'House':
            schemaType = 'House'
            jsonLd = {
                '@context': 'https://schema.org',
                '@type': schemaType,
                name: property.name,
                description: property.shortDesc,
                url: `${process.env.NEXT_PUBLIC_JSON_LD}/properties/${property.slug}`,
                image: property.cover,
                numberOfBedrooms: property.bedrooms,
                floorSize: {
                    "@type": "QuantitativeValue",
                    "value": property.livingArea,
                    "unitCode": "MTK"
                },
                "geo": { "@type": "GeoCoordinates", "latitude": Number(property.latitude), "longitude": Number(property.longitude) },
            }
            amenityFeature.length > 0 ? jsonLd.amenityFeature = amenityFeature : ''
            property.isPetFriendly ? jsonLd.petsAllowed = true : ''

            break;
        case 'Land':
            schemaType = 'RealEstateListing'
            jsonLd = {
                '@context': 'https://schema.org',
                '@type': schemaType,
                name: property.name,
                description: property.shortDesc,
                url: `${process.env.NEXT_PUBLIC_JSON_LD}/properties/${property.slug}`,
                image: property.cover,
                "datePosted": property.datePosted,
            }
            break;
        case 'Commercial':
            schemaType = 'RealEstateListing'
            jsonLd = {
                '@context': 'https://schema.org',
                '@type': schemaType,
                name: property.name,
                description: property.shortDesc,
                url: `${process.env.NEXT_PUBLIC_JSON_LD}/properties/${property.slug}`,
                image: property.cover,
                "datePosted": property.datePosted,
            }
            break;

        default:
            break;
    }

    return (
        <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            key="product-jsonld"
        />
    )
}

export default PropertyLdJson